(function() {

  var env = 'pre',
      server_url = '',
      activityCode = 'ca7c65ecad787e0d';
  if (typeof window !== 'undefined') {
    if (location.host.match(/^(dev|stage)/)) {
      env = 'stage'
    } else if (location.host.match(/^(pre-)/)) {
      env ='pre'
    } else if (location.host.match(/^(prod-|www)/)) {
      env ='prod'
    }
  }
  console.log('env', env)

  server_url = 'https://sensorsdata.vipkid.com/sa?project=default'
  var config = {
    'prod':
    {
      loginUrl: `//www.vipkid.com.cn/login`,
      signOutUrl: `//www.vipkid.com.cn/entry/logout`,
      applyUrl: `//www.vipkid.com.cn/signup`,
      apiURL: `/rest`,
      env: 'prod',
      saServer_url: server_url,
      activityCode,
      im: 'https://multi-im-chat.vipkid.com.cn'
    },
    'pre':
    {
      loginUrl: `//pre-www.vipkid.com.cn/login`,
      signOutUrl: `//pre-www.vipkid.com.cn/entry/logout`,
      applyUrl: `//pre-www.vipkid.com.cn/signup`,
      apiURL: `/rest`,
      env: 'pre',
      saServer_url: server_url,
      activityCode,
      im: 'https://pre-multi-im-chat.vipkid.com.cn'
    }
  }
  

  if (!config[env]) {
    server_url = 'https://sensorsdata.vipkid.com.cn/sa?project=test'
    config[env] = {
      loginUrl: `//${env}-www.vipkid-qa.com.cn/login`,
      signOutUrl: `//${env}-www.vipkid-qa.com.cn/entry/logout`,
      applyUrl: `//${env}-www.vipkid-qa.com.cn/signup`,
      apiURL: `/rest`,
      env,
      saServer_url: server_url,
      activityCode,
      im: 'http://stage-multi-im-chat.vipkid-qa.com.cn'
    }
  }

  if (typeof exports == "object") {
    module.exports = config[env];
  }

  if (typeof window !== "undefined") {
    window.$config = config[env];
  }
})()
